<template>
<div class="container">
<div class="lb">
<!-- <transition-group name="fade"> -->
 <div class="item" v-for="(v,i) in lb" :key="v.id" v-show="lb&&index==i" :style="{backgroundImage:'url('+picurl+v.pic+')'}">
  </div>
<!-- </transition-group> -->
</div>
</div>	
</template>

<style scoped>
.item{width:100%;overflow: hidden;padding:20% 0;background-position: center;
	background-size: 200%;background-repeat: no-repeat;
}	
.item img{max-width: none;position:relative;left:-25%;background: }
.lb-enter,.lb-enter-active{
	transition: opacity 1s;
}
.lb-leave-active,.lb-leave{
	opacity: 0;
}

</style>

<script>

export default {
	data:function(){
		return {
          lb:"",
          picurl:picurl,
          index:0,
          timer:"",
          mystyle:{
           //margin:"0 -25%",
          }
		};
	},
	mounted:function(){
		this.init();
		var _this=this;
		setTimeout(function(){
          _this.start();
		},1000)
		
	},
	methods:{
		setStyle:function(){
          var width=window.innerWidth;
          //this.mystyle.height=width/2+"px";

          // setTimeout(function(){
          // 	 //var pw=document.querySelector(".lb img").style.width;
          //    console.log(pw);
          // },300)
          
		},
		start:function(){
			var len=this.lb.length;
			var _this=this;
			this.timer=setInterval(function(){
				_this.index++;
               if(_this.index>=len){
               	_this.index=0;
               }
			},2000)
		},
		init:function(){
			var _this=this;
            fun.post(api,{},function(d){
               console.log(d);
            if(d.status==1){
             // _this.all.dt=d.info;
              _this.lb=d.info.lb;
              _this.setStyle();
            }
           },true)
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/other/test.vue